// extracted by mini-css-extract-plugin
export default {"container":"DataHistoryTab_container_hJex_","emptyDataContainer":"DataHistoryTab_emptyDataContainer_lc4Ov","spinAround":"DataHistoryTab_spinAround_RcgiZ"};